// extracted by extract-css-chunks-webpack-plugin
module.exports = {"card":"LandingPageAboutSection-090136179c17a2a6","content":"LandingPageAboutSection-9007e4e009fac5dc","image":"LandingPageAboutSection-00012ee0dbddfdcd"};